import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ToasterContainer = styled.div`
    background-color: #ff245e;
    border: solid 1px #ff245e;
    display: flex;
    justify-content: center;
    padding: 1em 1em 1em 2em;
    font-size: 0.875em;
    font-weight: 600;
    line-height: 1;
    text-align: center;
    color: #fff;
    flex-direction: row;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 15;
    transform: translate3d(0, 0, 0);

    &.transition-enter {
        transform: translate3d(0, -100%, 0);
    }

    &.transition-enter.transition-enter-active {
        transition: transform 0.3s;
        transition-timing-function: ease-out;
        transform: translate3d(0, 0, 0);
    }

    &.transition-exit {
        transform: translate3d(0, 0, 0);
    }

    &.transition-exit.transition-exit-active {
        transition: transform 0.3s;
        transition-timing-function: ease-in;
        transform: translate3d(0, -100%, 0);
    }

    &.transition-out {
        transform: translate3d(0, -100%, 0);
        transition: transform 0.3s;
    }
`;

const CloseToaster = styled.div`
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    font-family: Averta;
    font-size: 1.5em;
    line-height: 0.8;
    text-align: left;
    color: #ffffff;
    cursor: pointer;
`;

const ToasterText = styled.div`
    flex: 1;
    margin-left: 1em;
    margin-right: 1em;
`;

const closeToaster = () => {
    var toasterContainer = document.querySelectorAll('[data-toaster]')[0];
    toasterContainer.classList.add('transition-out');
};

const ToasterAlert = props => (
    <ToasterContainer data-toaster="true">
        <ToasterText>{props.content}</ToasterText>
        <CloseToaster onClick={closeToaster}>+</CloseToaster>
    </ToasterContainer>
);

ToasterAlert.propTypes = {
    content: PropTypes.string.isRequired
};

export default ToasterAlert;



// WEBPACK FOOTER //
// ./src/components/Donation/ToasterAlert.jsx